module.exports = __webpack_public_path__ + "static/media/rabbitfarm.899a0fca.png";